import { z } from 'zod';

/* Evento realtime do portal do publisher (TASK-PUB-29, ADR-0478 / ADR-0488). Broadcast
   unidirecional (server→client) via `PublisherNotifyDO`. União discriminada por `type`:

   - `pack_decision` — decisão final de moderação (approved/rejected/changes_requested). Canal
     ADICIONAL ao email da PUB-12 (ADR-0463). `reviewNotes` só em rejected/changes_requested.
   - `pack_status` — avanço intermediário do ciclo (submitted/scanning/reviewing). Informativo:
     o portal reflete o progresso sem reload (ADR-0488). Sem `reviewNotes`. */
export const packDecisionEvent = z.object({
  type: z.literal('pack_decision'),
  packId: z.string().min(1),
  version: z.string().min(1),
  status: z.enum(['approved', 'rejected', 'changes_requested']),
  reviewNotes: z.string().optional(),
});
export type PackDecisionEvent = z.infer<typeof packDecisionEvent>;

export const packStatusEvent = z.object({
  type: z.literal('pack_status'),
  packId: z.string().min(1),
  version: z.string().min(1),
  status: z.enum(['submitted', 'scanning', 'reviewing']),
});
export type PackStatusEvent = z.infer<typeof packStatusEvent>;

export const publisherNotifyEvent = z.discriminatedUnion('type', [
  packDecisionEvent,
  packStatusEvent,
]);
export type PublisherNotifyEvent = z.infer<typeof publisherNotifyEvent>;
